module.exports = __webpack_public_path__ + "9936ebecbb13f7c39e6d5cda8f584871.svg";